export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000
export const ONE_WEEK_IN_MS = 7 * ONE_DAY_IN_MS

export function dateStringToDisplayDate (dateString: string, includeSeconds: boolean = true): string {
  const result: string = new Date(dateString).toLocaleString('sv-SE')
  return includeSeconds ? result : result.substring(0, 16)
}

export function getLocalizedDateTimeString(dateStr: string, includeSeconds: boolean = true) {
  let secondFormat: '2-digit' | undefined = undefined
  if (includeSeconds) {
    secondFormat = '2-digit'
  }

  const date: Date = new Date(dateStr)
  if (date.getUTCFullYear() != new Date().getUTCFullYear()) {
    // Display year if it differs from current year
    return date.toLocaleString('sv-SE', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: secondFormat })
  }
  else {
    return date.toLocaleString('sv-SE', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: secondFormat })
  }
}

export function getSessionDateTimeSpan(fromDateStr: string, toDateStr: string, includeSeconds: boolean = true) {
  let secondFormat: '2-digit' | undefined = undefined
  if (includeSeconds) {
    secondFormat = '2-digit'
  }

  const fromDate: Date = new Date(fromDateStr)
  const formattedFromDate: string = getLocalizedDateTimeString(fromDateStr, includeSeconds)

  const toDate: Date = new Date(toDateStr)
  let formattedToDate: string
  if (fromDate.toDateString() != toDate.toDateString()) {
    formattedToDate = toDate.toLocaleString('sv-SE', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: secondFormat })
  }
  else {
    // If date is the same; only display date on fromDate
    formattedToDate = toDate.toLocaleString('sv-SE', { hour: '2-digit', minute: '2-digit', second: secondFormat })
  }

  return `${formattedFromDate}–${formattedToDate}`
}

export function dateStringToRestockDisplayDate (dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleString('sv-SE', { day: 'numeric', month: 'short' })
}

export function differenceInMinutes(date1str: string, date2str: string): number {
  const date1: Date = new Date(date1str)
  const date2: Date = new Date(date2str)
  return Math.floor(Math.abs(date1.getTime() - date2.getTime()) / 60000) // 60000 = milliseconds to minutes factor
}

export function getTodayText(): string {
  const today = new Date()
  return `${today.getDate()}/${today.getMonth() + 1}`
}

export function formatDateToYMD(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}